export type Locale = 'zh-CN' | 'en-US';

export const defaultLocale: Locale = 'zh-CN';
